import * as yup from 'yup'

const schema = yup.object().shape({
  content: yup
    .string()
    .max(5000, 'Quantidade de caracteres acima do permitido!'),
  contractingParty: yup.string(),
  contractingParties: yup
    .array()
    .of(yup.string())
    .required('Adicione pelo menos uma parte')
    .min(1, 'Adicione pelo menos uma parte'),
  contractedParty: yup.string(),
  contractedParties: yup
    .array()
    .of(yup.string())
    .required('Adicione pelo menos uma parte')
    .min(1, 'Adicione pelo menos uma parte'),
  contractType: yup.string(),
  contractPurpose: yup.string(),
  hasClauses: yup.string().required(),
  attachments: yup.mixed().fileUpload({
    fileGroup: 'pdfOnly',
    required: true,
    requiredMessage:
      'É necessário anexar pelo menos um arquivo para análise contratual',
    maxFiles: 1,
    maxFilesMessage: 'Só é permitido anexar 1 contrato por solicitação',
  }),
})

export default schema
